import { ICON_MAP } from '@constants';
import { formatTime } from '@/utils';
import { Popover } from 'antd';
import { PolicyStatus } from './PolicyStatus';

import classes from './ListItem.module.css';

const NONE_VALUE = '--';

/**
 * 获取保留2位小数的精确数字
 * @param {Number} value 原始数字
 * @returns {String}
 */
const getAccurateValue = (value) => {
  if (!value) {
    return NONE_VALUE;
  }

  const numberFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const parts = numberFormat.formatToParts(value);
  const partValues = parts.map((p) => p.value);
  // const currencySymbol = partValues.shift();
  const amount = partValues.join('');
  return `${amount}`;
};

export const NormalCell = (val) => (
  <div className={classes.normal_text}>{!val ? NONE_VALUE : `${val}`}</div>
);

/**
 * policy id cell
 * @param {String} val policy id
 */
export const PolicyIdCell = (val) => (
  <div className={classes.policy_id}>{`#${val}`}</div>
);

/**
 * status cell
 * @param {String} val status
 */
export const StatusCell = (val) => (
  <div className={classes.status_box}>
    <PolicyStatus status={val} />
  </div>
);

/**
 * order id cell
 * @param {String} val order id
 */
export const OrderIdCell = (val, name) => {
  const icon = ICON_MAP[name];

  if (!val) {
    return NONE_VALUE;
  }

  return (
    <div className={classes.order_id_cell}>
      {icon && <img className={classes.order_id_icon} src={icon} alt="" />}
      <span className={classes.normal_text}>
        {!val ? NONE_VALUE : `${val}`}
      </span>
    </div>
  );
};

/**
 * coverage period cell
 * @param time 创建时间
 */
export const CoveragePeriodCell = (time, _, timezone) => (
  <div className={classes.coverage_period}>
    {formatTime(time, '', timezone) || NONE_VALUE}
  </div>
);

/**
 * coverage cell
 * @param {Number} coverageNum 数量
 */
export const CoverageCell = (coverageNum) => {
  if (!coverageNum) {
    return <div className={classes.normal_text}>{NONE_VALUE}</div>;
  }
  return (
    <div className={classes.normal_text}>
      <span className={classes.coverage_num}>{`${coverageNum} `}</span>
      {`item${coverageNum > 1 ? 's' : ''}`}
    </div>
  );
};

/**
 * covered value cell
 * @param {Number} val 保额
 */
// export const CoveredValueCell = (val) => (<div className={classes.normal_text}>{getAccurateValue(val, '$')}</div>);

/**
 * covered value cell
 * @param {Number} val 保额
 */
export const CoveredValueCell = (val, _, __, row) => {
  const {
    customerCurrency, shopCurrency, shopSumAssured, customerSumAssured,
  } = row;
  if (customerCurrency === shopCurrency) {
    return (
      <div className={classes.normal_text}>
        {shopSumAssured || getAccurateValue(val, '$')}
      </div>
    );
  }
  return (
    <Popover content={customerSumAssured}>
      <div className={classes.normal_text}>{shopSumAssured}</div>
    </Popover>
  );
};

export const PremiumCell = (val, _, __, row) => {
  const {
    customerCurrency, shopCurrency, shopPremium, customerPremium,
  } = row;
  if (customerCurrency === shopCurrency) {
    return (
      <div className={classes.normal_text}>
        {shopPremium || getAccurateValue(val, '$')}
      </div>
    );
  }
  return (
    <Popover content={customerPremium}>
      <div className={classes.normal_text}>{shopPremium}</div>
    </Popover>
  );
};
